/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListProduct } from '../../models/api-response-list-product';

export interface ListProducts$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function listProducts(http: HttpClient, rootUrl: string, params: ListProducts$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListProduct>> {
  const rb = new RequestBuilder(rootUrl, listProducts.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListProduct>;
    })
  );
}

listProducts.PATH = '/v1/api/products/list';
